

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3 } from "@/components";
import productDetail from "./components/productDetail.vue"
@Component({
    components: {
        padHeadPanel3,productDetail
    },
})
export default class product extends Vue {

   
    public $refs: {
    };

    isScaning = false;

    created() {
    }
    async mounted() {
        
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/addProduct.vue